import { render, staticRenderFns } from "./pushReceiveDomainModal.vue?vue&type=template&id=2c76159e&scoped=true&"
import script from "./pushReceiveDomainModal.vue?vue&type=script&lang=js&"
export * from "./pushReceiveDomainModal.vue?vue&type=script&lang=js&"
import style0 from "./pushReceiveDomainModal.vue?vue&type=style&index=0&id=2c76159e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76159e",
  null
  
)

export default component.exports